import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import * as _ from 'lodash';

import { Segment } from 'shared/segments-navigation/segment.interface';
import { BaseRoutingPageComponent } from 'shared/base/_base-routing-page.component';
import { SegmentsNavigationComponent } from 'shared/segments-navigation/segments-navigation/segments-navigation.component';
import {ProductPanelComponent} from '../product-panel/product-panel.component';


@Component({
  template: '',
})
export class SegmentNavigationPageComponent extends BaseRoutingPageComponent implements OnInit {

  segments: Segment[] = [];

  @ViewChild(SegmentsNavigationComponent, {static: false}) segmentsNavigation: SegmentsNavigationComponent | void;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    super(router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  navigateToSegment(name: string): void {
    const rootUrl = _.get(this.route.snapshot, 'data.page.link');
    this.router.navigate([`${rootUrl}/${name}`]);
  }

  onRouteChange(event: NavigationEnd) {
    const segments = this.route.snapshot.data.segments;
    if (this.segments === segments) { return; }
    this.segments = this.route.snapshot.data.segments;
    const url = this.route.snapshot.children[0].url[0];
    if (!url) { return; }
    _.delay(() => {
      if (this.segmentsNavigation) {
        this.segmentsNavigation.setActive(url.path);
      }
    }, 100);
  }

  onSelectSegment(event: any) {
    this.navigateToSegment(event.name);
  }

}
